import { RouteRecordRaw } from 'vue-router'

const PARENT_VIEW = () => import('@/layout/routerView.vue')

const routes: RouteRecordRaw[] = [
  {
    path: 'system',
    name: 'system',
    children: [
      {
        path: 'dict',
        name: 'system_dict',
        component: PARENT_VIEW,
        redirect: '/system/dict/category',
        meta: { title: '字典管理', order: 40 },
        children: [
          {
            path: 'category',
            name: 'system_dict_category',
            component: () => import('@/views/Customer/Category/index.vue'),
            meta: { title: '客户分类', order: 10 }
          },
          {
            path: 'position',
            name: 'system_dict_position',
            component: () => import('@/views/Customer/Position/index.vue'),
            meta: { title: '客户岗位', order: 20 }
          },
          {
            path: 'relations-cate',
            name: 'system_dict_relations_cate',
            component: () => import('@/views/Customer/Maintain/Cate.vue'),
            meta: { title: '客户维护形式', order: 30 }
          },
          {
            path: 'sponsor-cate',
            name: 'system_dict_sponsor_cate',
            component: () => import('@/views/Customer/Sponsor/Cate.vue'),
            meta: { title: '客户赞助形式', order: 40 }
          }
        ]
      }
    ]
  },
  {
    path: 'customer',
    name: 'customer',
    component: () => import('@/layout/routerView.vue'),
    redirect: '/customer/list',
    meta: { title: '客户管理', icon: 'svg:menu-customer', order: 30 },
    children: [
      { path: 'list', name: 'customer_list', component: () => import('@/views/Customer/List/index.vue'), meta: { title: '客户列表' } },
      { path: 'visit', name: 'customer_visit', component: () => import('@/views/Customer/Visit/index.vue'), meta: { title: '客户拜访' } },
      { path: 'maintain', name: 'customer_maintain', component: () => import('@/views/Customer/Maintain/index.vue'), meta: { title: '关系维护' } },
      { path: 'sponsor', name: 'customer_sponsor', component: () => import('@/views/Customer/Sponsor/index.vue'), meta: { title: '赞助费' } }
    ]
  }
]

export default routes
